export default __webpack_public_path__ + "components/page-footer/static/icon-meteo365-a9378ef1fa5b5b04ae98d266382553a9.png";